/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tenant_Owner_InvalidInputs */



/**
* | output |
* | --- |
* | "That isn't a Discord user ID. Turn on Developer Mode in Discord, then right-click the person → Copy User ID." |
*
* @param {Tenant_Owner_InvalidInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const tenant_owner_invalid = /** @type {((inputs?: Tenant_Owner_InvalidInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tenant_Owner_InvalidInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Это не ID пользователя Discord. Включите в Discord «Режим разработчика», затем нажмите на человека правой кнопкой → «Копировать ID пользователя».")
	return /** @type {LocalizedString} */ ("That isn't a Discord user ID. Turn on Developer Mode in Discord, then right-click the person → Copy User ID.")
});